import { Col, Row } from "antd";
import Button from "components/button/Button";
import InputComponent from "components/formInput/Input";
import InputPassword from "components/formInput/InputPassword";
import { apiGetPostCodeInfo } from "helpers/api/clinic";
import { useTranslation } from "react-i18next";

const SignUp = ({ setScreen, formFormik }) => {
  const { t } = useTranslation();

  const { values, errors, handleChange, setFieldValue, handleSubmit, dirty } =
    formFormik;

  const handleChangePostCode = () => {
    const postCode = `${values?.address?.postal_code}`.replaceAll("-", "");
    setFieldValue("address.province", "");
    setFieldValue("address.name", ``);
    apiGetPostCodeInfo(postCode, (address) => {
      setFieldValue("address.province", address?.prefecture);
      setFieldValue("address.name", `${address?.city}${address?.area}`);
    });
  };

  const checkRequired =
    !dirty ||
    !values.clinic_name ||
    !values.clinic_name_furigana ||
    !values.address.postal_code ||
    !values.address.province ||
    !values.address.name ||
    !values.address.building ||
    !values.phone_number ||
    !values.email ||
    !values.confirmEmail ||
    !values.password ||
    !values.confirmPassword;

  return (
    <div className="clinic-container">
      <div className="clinic-title">{t("signUp.pageTitle")}</div>
      <form autoComplete="off">
        <div className="clinic-layout">
          <Row gutter={[24, 24]} justify={"space-between"} className="sign-up-form">
            <Col xl={12} lg={12} md={24}>
              <InputComponent
                title={t("signUp.nameFullWidth")}
                placeholder={t("signUp.nameFullPlaceholder")}
                name="clinic_name"
                value={values.clinic_name}
                error={errors?.clinic_name}
                onChange={handleChange}
              />
              <InputComponent
                title={t("signUp.nameFurigana")}
                placeholder={t("signUp.nameFuriPlaceholder")}
                name="clinic_name_furigana"
                value={values.clinic_name_furigana}
                error={errors?.clinic_name_furigana}
                onChange={handleChange}
              />
              <div className="address">
                <div className="clinic-input-title mt-20">
                  {t("signUp.address")}
                </div>
                <div className="clinic-row">
                  <span className="post-code-icon">
                    {t("signUp.addressSymbol")}
                  </span>
                  <InputComponent
                    name="address.postal_code"
                    value={values?.address?.postal_code}
                    error={errors?.address?.postal_code}
                    onChange={handleChange}
                  />
                  <div className="search-button" onClick={handleChangePostCode}>
                    {t("signUp.addressSearch")}
                  </div>
                </div>
                <InputComponent
                  placeholder={t("signUp.provincePlaceholder")}
                  name="address.province"
                  value={values.address?.province}
                  error={errors.address?.province}
                  onChange={handleChange}
                />
                <InputComponent
                  placeholder={t("signUp.address1Placeholder")}
                  name="address.name"
                  value={values.address?.name}
                  error={errors.address?.name}
                  onChange={handleChange}
                />
                <InputComponent
                  placeholder={t("signUp.address2Placeholder")}
                  name="address.building"
                  value={values.address?.building}
                  error={errors.address?.building}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col xl={12} lg={12} md={24}>
              <InputComponent
                title={t("signUp.phone")}
                className="input-right"
                name="phone_number"
                type="numberString"
                pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                value={values.phone_number}
                error={errors.phone_number}
                onChange={handleChange}
              />
              <div className="email-section">
                <InputComponent
                  title={t("signUp.email")}
                  name="email"
                  value={values.email}
                  error={errors.email}
                  onChange={handleChange}
                  className="input-right"
                />
                <InputComponent
                  des={t("signUp.forConfirm")}
                  name="confirmEmail"
                  value={values.confirmEmail}
                  error={errors.confirmEmail}
                  onChange={handleChange}
                  className="input-right"
                />
              </div>
              <div className="password-section">
                <div className="clinic-input-title">{t("signUp.password")}</div>
                <InputPassword
                  type="password"
                  name="password"
                  value={values.password}
                  error={errors.password}
                  onChange={handleChange}
                  className="input-right"
                />
                <InputPassword
                  type="password"
                  des={t("signUp.forConfirm")}
                  name="confirmPassword"
                  value={values.confirmPassword}
                  error={errors.confirmPassword}
                  onChange={handleChange}
                  className="input-right"
                />
                <Button
                  text={t("signUp.confirm")}
                  className="submit-button"
                  type="button"
                  onClick={handleSubmit}
                  disabled={checkRequired}
                //   onClick={() => setStatus(1)}
                />
              </div>
            </Col>
          </Row>
        </div>
      </form>
    </div>
  );
};

export default SignUp;
